<script lang="ts" setup>
	import useNotificationApi from '~/services/apis/notifications'

	defineProps<{
		planDetails: PolicyResponse | null
		isPending: boolean
	}>()

	const emits = defineEmits<{
		(event: 'activate'): void
		(event: 'reminder'): void
	}>()
	const { custodian_id } = useRoute().params
	const { getActivities } = useNotificationApi()

	const getRecord = (query?: object) =>
		getActivities({
			...query,
			policy_id: String(custodian_id)
		})
	const { formatDate } = useCustomDate()
	const tableCol: TableColumn = [
		{
			title: 'Activity',
			key: 'title'
		},
		{
			title: 'Date',
			key: 'date',
			dataIndex: 'created_at',
			customRender: ({ record }) => formatDate(record?.created_at, 'Do MMM YYYY')
		},
		{
			title: 'Time',
			key: 'time',
			dataIndex: 'created_at',
			customRender: ({ record }) => formatDate(record?.created_at, 'hh:mm A')
		}
	]
</script>

<template>
	<div>
		<my-cover-policy-label
			v-show="!isPending"
			label="Activities taken by this staff on this plan "
			:icon="{ name: 'bold-note', dir: 'documents' }"
		/>
		<ui-data-table
			table-columns-class="text-sm  py-2"
			:records="getRecord"
			:columns="tableCol"
			:scroll="{ y: 300 }"
			:show-limit="false"
		>
			<template #bodyCell="{ column, record }">
				<template v-if="column.key === 'title'">
					<div class="inline-flex items-center gap-2">
						<my-cover-activity-icon :type="record?.on_type ?? ''" />
						<span class="capitalize">{{ String(record?.title ?? 'N/A').replace('_', ' ') }}</span>
					</div>
				</template>
			</template>
		</ui-data-table>
	</div>
</template>
